import { createProject } from '../../../contactLogic/manage/index';
import {mapState} from "vuex";

export default {
  name: 'createArt',
  data() {
    return {
      projectName: '',
      projectArtist: '',
      projectArtistAddress: '',
      projectDescription: '',
      projectWebsite: '',
      projectLicense: '',
      projectBaseURI: '',
      mintPrice: '',
      iscode: 'image',
    };
  },
  computed: {
    ...mapState(['web3', 'ethersprovider', 'ethChainID', 'ethAddress']),
    isReady() {
      return this.web3 && this.ethersprovider && this.ethChainID && this.ethAddress;
    },
  },
  methods: {
    async onSubmit() {
      const params = {
        project_name: this.projectName,
        project_artist: this.projectArtist,
        project_artist_address: this.projectArtistAddress,
        project_description: this.projectDescription,
        project_website: this.projectWebsite,
        project_license: this.projectLicense,
        project_base_uri: this.projectBaseURI,
        project_mint_price: this.mintPrice,
        iscode: this.iscode === 'code',
      };

      const result = await createProject(params);

      if(result.code === 200) {
        this.$Notice.success({
          title: 'Submit Success！',
        });
      } else {
        this.$Notice.warning({
          title: 'Submit Failed！',
          desc: result && result.msg
        });
      }
    }
  },
  watch: {
    isReady(val) {
      if(val) {
        this.projectArtistAddress = this.ethAddress;
      }
    },
    ethAddress(val) {
      this.projectArtistAddress = val;
    }
  },
  created() {

  }
};
